import { css, keyframes } from '@emotion/react';
import { theme } from '@frontend/theme';
import { TASK_HIGHLIGHT_DURATION } from '../../constants';

const highlightAnimation = keyframes`
  0% {
    background-color: ${theme.colors.warning5};
  }

  80% {
    background-color: ${theme.colors.warning5};
  }

  100% {
    background-color: transparent;
  }
`;

export const containerStyle = (showHighlight: boolean) => [
  css`
    padding: ${theme.spacing(2.5, 3, 3, 3)};
    gap: ${theme.spacing(1.5)};
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${theme.colors.neutral20};
    position: relative;
    width: 100%;
    transition: background-color 0.2s ease-in-out;

    .row {
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};

      .chip:nth-child(n + 3) {
        flex: 0 1 auto;
        min-width: 0;
      }
    }

    :hover {
      cursor: pointer;
      background-color: ${showHighlight ? theme.colors.warning5 : theme.colors.neutral5};
    }
  `,
  showHighlight &&
    css`
      animation: ${highlightAnimation} ${TASK_HIGHLIGHT_DURATION}ms ease-out forwards;
    `,
];

export const containerForWidgets = css`
  padding: var(--fabric-space-gap-sm);
`;

export const loaderStyles = css`
  inset: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.black};
  opacity: 0.3;
`;

export const dueDateChipStyle = css`
  color: ${theme.font.colors.default};
  font-weight: ${theme.font.weight.bold};
`;

export const taskTitleContainer = css`
  flex: 1;
  min-width: 0;
  padding: ${theme.spacing(0.5, 0, 0, 0)};
  word-break: break-word;
`;

export const firstTaskItemRow = css`
  align-items: flex-start !important;
`;

export const callIntelIconStyle = css`
  color: var(--fabric-color-neutral-50);
  margin-top: var(--fabric-geometry-compact-space-padding-sm);
`;

// Most of the styles are picked from the Avatar component, but we need to add some of them to make it smaller
export const aiAssistantStyles = css`
  width: var(--fabric-number-n-4-px);
  height: var(--fabric-number-n-4-px);
  margin-top: var(--fabric-geometry-compact-space-padding-sm);
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: var(--fabric-geometry-compact-radius-md);

  background: linear-gradient(
    -90deg,
    var(--fabric-color-blue-10),
    var(--fabric-color-seaweed-5),
    var(--fabric-color-blue-10),
    var(--fabric-color-seaweed-5)
  );
  background-size: 400% 400%;
  animation: gradient 5s ease infinite;

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background: linear-gradient(
      -90deg,
      var(--fabric-color-blue-10),
      var(--fabric-color-seaweed-5),
      var(--fabric-color-blue-10),
      var(--fabric-color-seaweed-5)
    );
    background-size: 400% 400%;
    animation: gradient 5s ease infinite;
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export const flexWrapStyle = css`
  flex-wrap: wrap;
`;

export const dotIndicatorStyle = css`
  position: static;
  margin-top: ${theme.spacing(1.5)};
  width: 8px;
  height: 8px;
  border: none;
  border-radius: 50%;
`;
